import stringUtil from '@/functions/utils/string';

export const message = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    error: '',
    warnings: [],
    info: '',
    title: '',
    isShowNewVersionUploaded: false,
    userContractHeadIdOfNewVersion: '',
    color: 'night_b',
    isLoginError: false
  },
  getters: {
    error: (state) => state.error,
    warnings: (state) => state.warnings,
    info: (state) => state.info,
    title: (state) => state.title,
    isShowInfo: (state) => state.info.length > 0,
    isShowWarnings: (state) => state.warnings.length > 0,
    isShowNewVersionUploaded: (state) => state.isShowNewVersionUploaded,
    userContractHeadIdOfNewVersion: (state) => state.userContractHeadIdOfNewVersion,
    isShowError: (state) => state.error.length > 0,
    isLoginError: (state) => state.isLoginError
  },
  mutations: {
    set(state, payload) {
      if (payload.error) {
        state.error = payload.error;
      }
      if (payload.warnings) {
        state.warnings = payload.warnings;
      }
      if (payload.info) {
        state.info = payload.info;
      }
      if (payload.title) {
        state.title = payload.title;
      }
      if (payload.color) {
        state.color = payload.color;
      }
      if (Object.prototype.hasOwnProperty.call(payload, 'isLoginError')) {
        state.isLoginError = payload.isLoginError;
      }
    },
    setIsShowNewVersionUploaded(state, payload) {
      state.isShowNewVersionUploaded = payload;
    },
    setUserContractHeadIdOfNewVersion(state, payload) {
      state.userContractHeadIdOfNewVersion = payload;
    },
    clear(state) {
      state.error = '';
      state.warnings = [];
      state.info = '';
      state.title = '';
      state.isShowNewVersionUploaded = false;
      state.userContractHeadIdOfNewVersion = '';
      state.color = 'night_b';
      state.isLoginError = false;
    }
  },
  actions: {
    /**
     * エラーメッセージ表示
     */
    setErrorMessage(context, payload) {
      context.commit('clear');
      context.commit('set', {
        error: payload.message,
        title: payload.title ? payload.title : 'Error',
        isLoginError: payload.isLoginError ? payload.isLoginError : false
      });
    },
    /**
     * システムエラーメッセージ表示
     */
    setSystemErrorMessage(context, payload) {
      context.commit('clear');
      context.commit('set', {
        error: stringUtil.createSystemErrorMsg(payload.message),
        title: 'システムエラー',
        isLoginError: payload.isLoginError ? payload.isLoginError : false
      });
    },
    /**
     * 警告メッセージ（複数）表示
     */
    setWarningMessage(context, payload) {
      context.commit('clear');
      context.commit('set', {
        warnings: payload.message,
        title: payload.title ? payload.title : 'Warning',
        isLoginError: payload.isLoginError ? payload.isLoginError : false
      });
    },
    /**
     * インフォメーションメッセージ表示
     */
    setInfoMessage(context, payload) {
      context.commit('clear');
      context.commit('set', {
        info: payload.message,
        color: payload.color ? payload.color : 'night_b',
        isLoginError: false
      });
      setTimeout(() => {
        context.commit('clear');
      }, 6000);
    },
    /**
     * バージョンアップロード完了メッセージ表示
     */
    setIsShowNewVersionUploaded(context, payload) {
      context.commit('clear');
      context.commit('setIsShowNewVersionUploaded', true);
      console.clear();
      context.commit('setUserContractHeadIdOfNewVersion', payload);
      setTimeout(() => {
        context.commit('clear');
      }, 43200000);
    },
    /**
     * インフォメーションメッセージ表示
     */
    setDragDropInfoMessage(context, payload) {
      context.commit('clear');
      context.commit('set', {
        info: payload.message,
        color: payload.color ? payload.color : 'night_b',
        isLoginError: false
      });
      setTimeout(() => {
        context.commit('clear');
      }, 300000); // 明示的にメッセージをクリアしているため、5分という長時間に設定
    },
    /**
     * 全メッセージ削除
     */
    clearMessages(context) {
      context.commit('clear');
    }
  }
};
